import { Badges, H4, H5, P } from "../../../../AbstractElements";
import { AppIdeas, EstablishedNewTheAppIdeaRepository, ViewItOnGithub } from "../../../../Utils/Constants";

const AppIdeasTimeline = () => {
  const AppIdeaText: string = "developers who are just beginning their learning process. those who often concentrate on developing programmes with a user interface.";

  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-picture bg-primary">
        <i className="icon-pencil-alt" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="warning">{AppIdeas}</Badges>
        </div>
        <H4 className="m-0 vertical-timeline-element-subtitle">{EstablishedNewTheAppIdeaRepository}</H4>
        <P className="mb-0">{AppIdeaText}</P>
        <div className="time-content pt-2">
          <i className="icon-github"></i>
          <H5>{ViewItOnGithub}</H5>
        </div>
        <span className="cd-date">February 02 2024</span>
      </div>
    </div>
  );
};

export default AppIdeasTimeline;
